import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EMMATableRowCellPriorityService {
  private readonly cellClicked = new Subject<void>();

  cellClicked$ = this.cellClicked.asObservable();

  notifyOnCellClicked() {
    this.cellClicked.next();
  }
}
